import React from 'react';
import { Loyalty } from '@mui/icons-material';
interface OverviewUpgradePlaceholderProps {
  onUpgrade: () => void;
}

const OverviewUpgradePlaceholder: React.FC<OverviewUpgradePlaceholderProps> = ({
  onUpgrade
}) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '3rem',
      textAlign: 'center',
      width: '500px',
      background: '#fff',
      borderRadius: 12,
      boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
    }}>
      {/* Icon */}
      <div style={{
        width: '80px',
        height: '80px',
        background: 'linear-gradient(115deg, rgb(34, 34, 69) 25%, rgb(-77, 182, 159) 162%)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 2rem',
        fontSize: '2rem'
      }}>
        <Loyalty style={{ color: 'white', fontSize: '3rem' }} />
      </div>

      {/* Title */}
      <h2 style={{
        fontSize: '1.75rem',
        fontWeight: '600',
        color: '#1a202c',
        marginBottom: '1rem',
        lineHeight: '1.3'
      }}>
        Plan Required
      </h2>

      {/* Description */}
      <p style={{
        fontSize: '1.1rem',
        color: '#4a5568',
        lineHeight: '1.6',
        marginBottom: '2rem',
        maxWidth: '500px'
      }}>
        The Executive Overview dashboard requires a valid plan to access comprehensive insights from your data.
      </p>

      {/* Features list */}
      <div style={{
        background: '#f7fafc',
        borderRadius: '12px',
        padding: '1.5rem',
        marginBottom: '2rem',
        textAlign: 'left',
        maxWidth: '400px',
        width: '100%'
      }}>
        <h3 style={{
          fontSize: '1rem',
          fontWeight: '600',
          color: '#2d3748',
          marginBottom: '1rem'
        }}>
          Executive Overview includes:
        </h3>
        <ul style={{
          listStyle: 'none',
          padding: 0,
          margin: 0,
          fontSize: '0.95rem',
          color: '#4a5568'
        }}>
          <li style={{ marginBottom: '0.5rem', display: 'flex', alignItems: 'center' }}>
            <span style={{ color: '#48bb78', marginRight: '0.5rem' }}>✓</span>
            Key pain points and operational challenges
          </li>
          <li style={{ marginBottom: '0.5rem', display: 'flex', alignItems: 'center' }}>
            <span style={{ color: '#48bb78', marginRight: '0.5rem' }}>✓</span>
            Notable successes and positive trends
          </li>
          <li style={{ marginBottom: '0.5rem', display: 'flex', alignItems: 'center' }}>
            <span style={{ color: '#48bb78', marginRight: '0.5rem' }}>✓</span>
            Immediate priorities for action
          </li>
          <li style={{ marginBottom: '0.5rem', display: 'flex', alignItems: 'center' }}>
            <span style={{ color: '#48bb78', marginRight: '0.5rem' }}>✓</span>
            Performance insights for staff across your teams
          </li>
        </ul>
      </div>

      {/* Upgrade button */}
      <button
        onClick={onUpgrade}
        style={{
          background: 'linear-gradient(115deg, rgb(34, 34, 69) 25%, rgb(-77, 182, 159) 162%)',
          color: '#fff',
          border: 'none',
          borderRadius: '12px',
          padding: '1rem 2rem',
          fontSize: '1.1rem',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
          minWidth: '200px'
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 6px 16px rgba(102, 126, 234, 0.4)';
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.3)';
        }}
      >
        Get Started with a Plan
      </button>
    </div>
  );
};

export default OverviewUpgradePlaceholder;
